<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-3">
        Classez les molécules suivantes en fonction de leur solubilité aqueuse (solubilité dans
        l'eau) :
      </p>

      <p class="pl-8 mb-4">
        <v-img style="max-width: 279px" :src="imageName" />
      </p>

      <drag-to-rank-input-fr
        v-model="inputs.relativeSolubilities"
        :items="items"
        class="mb-0"
        style="max-width: 430px"
        prepend-text="Le plus soluble"
        append-text="Le moins soluble"
      />
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import ChemicalLatex from '../displayers/ChemicalLatex';
import StembleLatex from '@/tasks/components/StembleLatex';
import DragToRankInputFr from '@/tasks/components/inputs/DragToRankInputFr.vue';
import {prefixPublicAsset} from '@/common/plugins/public-asset-plugin';

export default {
  name: 'Question498',
  components: {
    DragToRankInputFr,
    ChemicalLatex,
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        relativeSolubilities: [],
      },
      items: ['Molécule A', 'Molécule B', 'Molécule C'],
    };
  },
  computed: {
    imageName() {
      return prefixPublicAsset('/img/assignments/rankingWaterSolubilities.png');
    },
  },
};
</script>
